import React from 'react';

/**
 * Cattura errori runtime che altrimenti farebbero diventare l'app bianca.
 * Mostra un fallback UI leggibile con dettaglio errore + pulsante ricarica.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log strutturato in console + eventuale invio a backend in futuro
    console.error('[ErrorBoundary] Runtime error caught:', error);
    console.error('[ErrorBoundary] Component stack:', errorInfo?.componentStack);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        data-testid="error-boundary-fallback"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          background: '#0f172a',
          color: '#f1f5f9',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div style={{ maxWidth: 720, width: '100%' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>⚠️</div>
          <h1 style={{ fontSize: 28, margin: '0 0 8px 0', fontWeight: 800 }}>
            Ops! Qualcosa non ha funzionato
          </h1>
          <p style={{ fontSize: 15, color: '#94a3b8', marginBottom: 24 }}>
            Si è verificato un errore imprevisto. I tuoi dati sono al sicuro. Ricarica la pagina o torna alla dashboard.
          </p>

          <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
            <button
              onClick={this.handleReload}
              data-testid="error-reload-btn"
              style={{
                background: '#06b6d4',
                color: '#fff',
                border: 'none',
                padding: '12px 22px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              🔄 Ricarica pagina
            </button>
            <button
              onClick={this.handleHome}
              data-testid="error-home-btn"
              style={{
                background: 'transparent',
                color: '#f1f5f9',
                border: '1px solid #334155',
                padding: '12px 22px',
                borderRadius: 6,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              🏠 Vai alla Dashboard
            </button>
          </div>

          <details
            style={{
              background: '#1e293b',
              border: '1px solid #334155',
              borderRadius: 6,
              padding: 16,
              fontSize: 12,
              fontFamily: 'monospace',
            }}
          >
            <summary style={{ cursor: 'pointer', color: '#f59e0b', fontWeight: 600 }}>
              Dettagli tecnici (mostra al supporto)
            </summary>
            <div style={{ marginTop: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              <strong style={{ color: '#ef4444' }}>Errore:</strong>{'\n'}
              {String(this.state.error?.message || this.state.error || 'unknown')}
              {this.state.errorInfo?.componentStack && (
                <>
                  {'\n\n'}
                  <strong style={{ color: '#ef4444' }}>Stack componente:</strong>
                  {'\n'}
                  {this.state.errorInfo.componentStack.substring(0, 1500)}
                </>
              )}
            </div>
          </details>
        </div>
      </div>
    );
  }
}
